import React from 'react';
import styled from 'styled-components';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.main`
  display: flex;
  flex: 1;
  margin-top: 80px;
  min-height: calc(100vh - 80px);
  background: var(--color-background);
`;

const ContentArea = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'showSidebar',
})`
  flex: 1;
  padding: 40px clamp(20px, 4vw, 48px);
  margin-left: ${({ showSidebar }) => showSidebar ? '250px' : '0'};  /* Sidebar width */
  transition: margin-left var(--transition-speed) ease;
  background-color: var(--color-background);
  max-width: 100%;
  
  @media (max-width: 768px) {
    margin-left: 0;
    padding: 24px 16px;
  }
`;

const SkipLink = styled.a`
  position: absolute;
  top: -40px;
  left: 0;
  padding: var(--space-xs) var(--space-sm);
  background-color: var(--color-primary);
  color: white;
  z-index: 200;
  transition: top 0.3s ease;
  
  &:focus {
    top: 0;
  }
`;

const Layout = () => {
  const location = useLocation();
  
  // Determine which section should display a sidebar
  const sidebarSection = ['artists', 'settings', 'news'].find((section) =>
    location.pathname.startsWith(`/${section}`)
  );
  const showSidebar = Boolean(sidebarSection);

  return (
    <LayoutContainer>
      <SkipLink href="#main-content">Skip to main content</SkipLink>
      <Header />
      <MainContent>
        {showSidebar && <Sidebar section={sidebarSection} />}
        <ContentArea showSidebar={showSidebar} id="main-content">
          <Outlet />
        </ContentArea>
      </MainContent>
    </LayoutContainer>
  );
};

export default Layout;
